import styled from 'styled-components';
import { getPackageGradient } from '@/features/Profile/core/ActivePackageCard/ActivePackageCard.helpers';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Card = styled.article<{ $packageName: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 287px;
  gap: 16px;
  padding: 25px 20px;
  border-radius: 21px;
  background: ${({ $packageName }) => getPackageGradient($packageName)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 25px;
  gap: 10px;
`;

export const NameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Name = styled(Typography.Body).attrs({ $variant: '6' })`
  font-size: 16px;
`;

export const BenefitBadge = styled.span`
  padding: 5px 10px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.palette.system.blue};
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 13px;
  line-height: 16px;
  white-space: nowrap;
`;

export const CompactBenefitBadge = styled.span`
  display: inline-flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.blue};
`;

export const AdditionalDiscountBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  padding: 9px 13px 10px 12px;
  border-radius: 0 0 0 21px;
  background-color: #f39d16;
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  white-space: nowrap;
`;

export const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OriginalPrice = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 15px;
  font-weight: 700;
  text-decoration: line-through;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

export const Price = styled(Typography.Numbers)`
  font-size: 20px;
  font-weight: 700;
`;

export const Period = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 13px;
`;

export const Features = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0;
  list-style: none;
`;

export const Feature = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  padding: 5px 0;
  svg {
    flex: 0 0 11px;
  }
`;

export const ConnectButton = styled(Button)`
  height: 50px;
  margin-top: auto;
  background-color: ${({ theme, appearance }) =>
    appearance === 'secondary'
      ? theme.palette.system.blue
      : theme.palette.primary.background};
`;
